import * as React from "react";
const SvgFiRrLocationAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-location-alt_svg__a)">
      <path
        fill="#062147"
        d="M12 16a3 3 0 0 0 1.342-.314l2-1A2.99 2.99 0 0 0 17 12V9.033a2.99 2.99 0 0 0-1.658-2.683l-2-1a3.01 3.01 0 0 0-2.683 0l-2 1A2.99 2.99 0 0 0 7 9.033V12a2.99 2.99 0 0 0 1.658 2.684l2 1A3 3 0 0 0 12 16m-3-4V9.033a1 1 0 0 1 .051-.3l2.18 1.09a1.72 1.72 0 0 0 1.538 0l2.18-1.09a1 1 0 0 1 .051.3V12a.99.99 0 0 1-.553.895l-2 1a1.01 1.01 0 0 1-.895 0l-2-1A.99.99 0 0 1 9 12m10 10h-2.709l3.487-3.222c4.296-4.295 4.296-11.26 0-15.556-4.295-4.296-11.26-4.296-15.556 0-4.296 4.295-4.296 11.26 0 15.556L7.709 22H5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2M5.636 4.636a9 9 0 0 1 12.757 12.7l-3.985 3.681A3.513 3.513 0 0 1 9.571 21l-3.935-3.636a9.01 9.01 0 0 1 0-12.728"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-location-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLocationAlt;
